<!-- Footer -->
<section class="flex flex-auto justify-center w-full ">
    <footer class="bg-white w-full sm:mb-0 p-4 dark:bg-slate-900">
        <div class="w-full sm:px-15">
            <!--Grid-->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 py-14">
                <div class="flex flex-col justify-center items-center">
                    @if(view.site && view.site?.id != 119 && view.site?.id !== 120 && view.site?.id !== 118 && view.site?.id !== 163) {
                    <a class="flex justify-center mb-5" [routerLink]="'/'">
                        @if(view.site?.logoUrl) {
                        <img class="w-100 rounded-lg" [alt]="view.site?.name" [src]="view.site?.logoUrl">
                        }
                    </a>
                    }
                    @if(view.site && (view.site?.id === 120 || view.site?.id === 118 || view.site?.id === 163)) {
                    <a class="flex justify-center mb-5" [routerLink]="'/'">
                        @if(view.site?.logoUrl2) {
                        <img class="w-60 rounded-lg" [alt]="view.site?.name" [src]="view.site?.logoUrl2">
                        }
                    </a>
                    }
                    @if(view.site && view.site?.id === 119) {
                    <a class="flex justify-center mb-5" [routerLink]="'/'">
                        <img class="w-40 rounded-lg" [alt]="view.site?.name"
                            src="assets/images/logo/the-travel-department-logo.png">
                    </a>
                    }
                    @if(view.site?.slogan) {
                    <p class="ml-1 text-primary-500 dark:text-white text-center text-3xl font-secondary">
                        {{view.site?.slogan}}
                    </p>
                    }
                    @if(view.site?.id === 82) {
                    <div class="flex flex-col items-center">
                        <h3 class="text-center font-semibold tracking-wide mb-2">Business Hours</h3>
                        <p class="text-center">Monday - Friday: <span class="text-primary-500">8h30 - 16h30</span></p>
                    </div>
                    }
                    @if(view.site?.id === 87) {
                    <div class="flex flex-col items-center">
                        <h3 class="text-center font-semibold tracking-wide mb-2">Business Hours</h3>
                        <p class="text-center">Monday - Friday: <span class="text-primary-500">08h00 - 16h30</span></p>
                    </div>
                    }
                    @if(view.site?.id === 72) {
                    <div class="flex flex-col items-center">
                        <h3 class="text-center font-semibold tracking-wide mb-2">Consultation Hours</h3>
                        <p class="text-center">Monday - Friday: <span class="text-primary-500">09h00 - 16h00</span></p>
                    </div>
                    }
                    @if(view.site?.id === 80) {
                    <div class="flex items-center">
                        <div><img class="w-20" src="assets/icons/master-card.jpg" alt="master card logo"></div>
                        <div><img class="w-20" src="assets/icons/visa-card.jpg" alt="visa card logo"></div>
                        <div><img class="w-20" src="assets/icons/paypal.jpg" alt="paypal logo"></div>
                    </div>
                    }

                </div>
                <!-- End Col -->

                @if(view.site?.id == 79) {
                <div class="w-full flex flex-col items-center md:items-start justify-start text-center md:text-left">
                    <h1 class="text-3xl tracking-wider mb-2">Quick Links</h1>
                    @if (view.site?.profile.heading.border==1) {
                    <div class="flex items-baseline md:justify-start sm:justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }
                    <ul class="mt-3">
                        <li
                            class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer" [routerLink]="['/media-center']">Newsletters</a>
                        </li>
                    </ul>
                </div>
                }
                <!--End Col-->

                <div class="w-full flex flex-col items-center justify-center text-center md:text-left">
                    <h1 class="text-3xl tracking-wider mb-2">Contact</h1>

                    @if (view.site?.profile.heading.border == 1) {
                    <div class="flex items-baseline justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }

                    <ul class="flex flex-col items-center mt-3 space-y-3">
                        @if(view.site?.address){
                        <li class="text-primary-500">
                            <a class="flex items-start text-center">
                                <mat-icon class="icon-size-5 text-accent mr-3 mt-1 shrink-0"
                                    svgIcon="heroicons_outline:map"></mat-icon>
                                <span>{{ view.site?.address }}</span>
                            </a>
                        </li>
                        }
                        @if(view.site?.telephone) {
                        <li class="text-primary-500 text-center">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:phone"></mat-icon>
                                {{ view.site?.telephone }}
                            </a>
                        </li>
                        }
                        @if(view.site?.id === 104) {
                        <li class="text-primary-500">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:phone"></mat-icon>
                                +27 82 923 6235 <span class="text-accent-500 text-sm ml-3">(Emergency)</span>
                            </a>
                        </li>
                        }
                        @if(view.site?.id === 72) {
                        <li class="text-primary-500">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:phone"></mat-icon>
                                +264 81 400 4296 <span class="text-accent-500 text-sm ml-3">(Emergency)</span>
                            </a>
                        </li>
                        }
                        @if(view.site?.id === 98) {
                        <li class="text-primary-500 cursor-pointer">
                            <a href="mailto:anel@southlake.co.za" class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="feather:mail"></mat-icon>
                                anel&#64;southlake.co.za
                            </a>
                        </li>
                        }
                        @if(view.site?.emailAddress){
                        <li class="text-primary-500 cursor-pointer text-center">
                            <a [href]="view.emailLink" class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:envelope"></mat-icon>
                                {{ view.site?.emailAddress }}
                            </a>
                        </li>
                        }
                        @if(view.site?.id === 74) {
                        <li class="text-center">
                            <a href="https://optima-vibe-travel.1-esim.com/" target="_blank"
                                class="flex items-center justify-center relative text-primary-500 transition duration-300 hover:text-accent hover:scale-105 hover:drop-shadow-md group">
                                <mat-icon class="icon-size-5 text-accent mr-3 mb-1"
                                    svgIcon="heroicons_outline:device-phone-mobile"></mat-icon>
                                Buy Your E-sim Data Here
                                <span
                                    class="absolute left-0 bottom-0 w-0 h-[2px] bg-accent transition-all duration-300 group-hover:w-full"></span>
                            </a>
                        </li>
                        <li class="text-primary-500">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="mat_outline:train"></mat-icon>
                                +27 83 479 2416 <span class="text-[#1B6B4E] text-sm ml-3">(Optima Rail)</span>
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                <!-- End Col -->

                <div class="flex flex-col">
                    <div class="flex mt-4 space-x-4 justify-center ">
                        @if(view.site?.socialUrlFacebook) {
                        <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                            class="group relative w-8 h-8 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:facebook'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlInstagram) {
                        <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                            class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:instagram'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlTwitter) {
                        <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                            class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:twitter'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlLinkedIn) {
                        <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                            class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:linkedin'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlPinterest) {
                        <a href="{{view.site?.socialUrlPinterest}}" target="_blank"
                            class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <svg fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M16.292 5C10.536 5 7.48 8.866 7.48 13.077c0 1.955 1.039 4.392 2.707 5.168.253.118.387.064.443-.18.047-.185.273-1.089.373-1.511a.402.402 0 0 0-.095-.386c-.55-.667-.988-1.896-.988-3.041 0-2.942 2.228-5.787 6.021-5.787 3.28 0 5.571 2.23 5.571 5.426 0 3.61-1.82 6.108-4.191 6.108-1.309 0-2.291-1.081-1.978-2.413.378-1.584 1.106-3.298 1.106-4.438 0-1.026-.552-1.883-1.685-1.883-1.341 0-2.415 1.385-2.415 3.241 0 1.182.4 1.978.4 1.978s-1.323 5.593-1.563 6.634c-.413 1.765.051 4.625.094 4.876.021.134.172.18.252.066.129-.175 1.725-2.565 2.174-4.292l.828-3.171c.439.829 1.707 1.531 3.061 1.531 4.021 0 6.923-3.703 6.923-8.299C24.52 8.301 20.92 5 16.292 5z">
                                    </path>
                                </g>
                            </svg>
                        </a>
                        }
                        @if(view.site && (view.site.id === 146 || view.site.id === 72) ) {
                        <a href="{{view.site?.socialUrlYouTube}}" target="_blank"
                            class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:youtube'"></mat-icon>
                        </a>
                        }
                        <!-- @if(view.site) {
                            <a href="https://www.xltravel.co.za/xlgo/" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <img src="/assets/icons/xlgo-1.png" alt="">
                            </a>
                        } -->
                    </div>
                    <div class="flex justify-center items-center mt-20">
                        @if(view.site?.id != 79 && view.site?.id !== 98 && view.site?.id !== 154 && view.site?.id !== 80
                        && view.site?.id !== 76 && view.site?.id !== 72 && view.site?.id !== 89 && view.site?.id !== 124
                        && view.site?.id !== 70 && view.site?.id !== 74 && view.site?.id !== 96 && view.site?.id !== 163) {
                        <div><img class="w-20" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-20" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        }
                        @if(view.site?.id === 74) {
                        <div><img class="w-20" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-20" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        }
                        @if(view.site?.id === 79) {
                        <div><img class="" src="assets/images/logo/xl-stellenbosch-travel-member.jpg"
                                alt="xl-member logo"></div>
                        }
                        @if(view.site?.id === 80) {
                        <div><img class="w-18 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="" src="assets/images/logo/air-portugal.png" alt="air portugal logo"></div>
                        <div><img class="w-18 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-16 mr-5" src="assets/images/logo/xl-member-small.jpg" alt="xl-member logo">
                        </div>
                        }
                        @if(view.site?.id === 89) {
                        <div><img class="w-18 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-30 mr-5" src="assets/images/logo/gsta-logo.png" alt="gsta logo"></div>
                        }
                        @if(view.site?.id === 72) {
                        <div><img class="w-18 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-18 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-18 mr-3" src="assets/images/logo/New ANTA Logo .png" alt="anta logo"></div>
                        <div><img class="w-18 mr-3" src="assets/images/logo/NTB-registered-logo.png" alt="ntb logo">
                        </div>
                        }
                        @if(view.site?.id === 124 || view.site?.id === 70) {
                        <div><img class="w-12 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-12 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-36" src="assets/images/xl-travel/flight_specials_homepage_033.jpg"
                                alt="CATHSSETA logo"></div>
                        }
                        @if(view.site?.id === 154) {
                        <div><img class="w-12 mr-3" src="assets/images/logo/xl-member-small.jpg" alt="xl-member logo">
                        </div>
                        <div><img class="w-12 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-12 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-12" src="assets/images/logo/CATHSSETA.png" alt="CATHSSETA logo"></div>
                        }
                        @if(view.site?.id === 98) {
                        <div><img class="w-20 mr-5" src="assets/images/logo/xl-member-small.jpg" alt="xl-member logo">
                        </div>
                        <div><img class="w-20 mr-5" src="assets/images/logo/SAACI.jpg" alt="SAACI logo"></div>
                        <div><img class="w-20" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        }
                        @if(view.site?.id === 76) {
                        <div><img class="w-14 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-14 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-16" src="assets/images/logo/UFTAA.png" alt="UFTAA logo"></div>
                        }
                        @if(view.site?.id === 96) {
                        <div><img class="w-14 mr-3" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-14 mr-3" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                        <div><img class="w-16" src="assets/images/logo/egencia.png" alt="UFTAA logo"></div>
                        }
                    </div>
                </div>
            </div>
            <!--Grid-->
            <div class="py-7 border-t border-gray-200">
                <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row">
                    <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}}
                        <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.
                    </p>
                    @if(view.pages && view.site?.id !== 58) {
                    <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                        @for(page of view.pages; track page) {
                        <li><a [routerLink]="['/policy', page.seo.alias]"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a>
                        </li>
                        }
                        @if(view.site?.id === 146) {
                        <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/PAIA-Manual.pdf'" target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">PAIA
                                Manual</a>
                        </li>
                        }
                        @if(view.site?.id === 86) {
                        <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/Aloe-Travel-Booking-Form-ts-cs.pdf'"
                                target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download
                                Booking Form and Standard T&C's</a></li>
                        <li><a [href]="'http://xl-api.travelfind.me/assets/uploads/15588_1298515_2023-11-21_14-11_PAIANew.pdf'"
                                target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">Download
                                Promotion of Access to Information Act</a></li>
                        }
                    </ul>
                    }
                </div>
            </div>
        </div>
    </footer>
</section>